/* eslint-disable react/forbid-dom-props */
import classnames from 'classnames';
import React from 'react';
import styles from './EntityFormFieldSet.scss';
import Strike from '../../utils/Strike';
import useLayoutDirection from '../../utils/Translations/useLayoutDirection';
import useHelpNoteTitleIfPresent from '../../utils/Translations/useHelpNoteTitleIfPresent';
const EntityFormFieldSet = ({ children, className = '', hasNoStrike = false, notes, rowWrapper = true, separated = false, title, tooltipTitle, }) => {
    const { direction, startSide, isLayoutRTL } = useLayoutDirection();
    const helpNoteTitle = useHelpNoteTitleIfPresent(title);
    const body = (<>
      {children}

      {separated && (<div className="col-xs-12 mt-15">
          <hr className={styles.hr}/>
        </div>)}
    </>);
    return (<div className={classnames({
        [styles.rtlContainer]: isLayoutRTL,
    })} data-layout-direction={direction} dir={direction}>
      {title && !hasNoStrike ? (<Strike isSubsection title={title} tooltipTitle={tooltipTitle}/>) : (title && (<div className={classnames(styles.title, startSide === 'right' ? 'text-right' : 'text-left')} title={tooltipTitle || helpNoteTitle}>
            {title}
          </div>))}

      {notes && (<div className={classnames('mb-10', startSide === 'right' ? 'text-right' : 'text-left', { 'mt-10': !title })}>
          {notes}
        </div>)}

      {rowWrapper ? (<div className={classnames('row', className)}>{body}</div>) : (body)}
    </div>);
};
export default EntityFormFieldSet;
